import { ListPageLayout } from "@/components/list-page-layout";
import { usePageTitle } from "@/hooks/use-page-title";
import { WebpagesDataTable } from "./webpages-data-table";

export default function WebpageListView() {
  usePageTitle("Web Page List");

  return (
    <ListPageLayout pageType="webpages::list" title="Web Page List">
      <WebpagesDataTable />
    </ListPageLayout>
  );
}
